/* eslint-disable react/display-name */
import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Checkbox, Col, Empty, Row, Space, Tabs } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatDateTime, formatDateWithoutTime, getSupplierMenuSelect, numberWithComma } from 'helpers/format'
import { GrnListReq, GrnData } from 'Store/grn/types'
import { grnListAPI, grnListBySupActionAPI } from 'Store/grn/api'
import {
  selectGrnActionEvent,
  selectGrnDetail,
  selectGrnDetailEvent,
  selectGrnList,
  selectGrnListBySub,
  selectGrnListBySupEvent,
  selectGrnListEvent,
} from 'Store/grn/selector'
import { selectPaymentActionEvent } from 'Store/grn-payment/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/grn-payment/actions'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { selectAllSupplierList } from 'Store/supplier/selector'
import { GrnStatus, menuPayDeptStatus } from 'helpers/constanst'
import { SelectItem } from 'Components/form'
import { TableListPage } from 'Components/common/Table'
import { Pagination } from 'Components/Pagination'
import { getUnixTime } from 'helpers/sorting'
import { cloneDeep } from 'lodash'
import { SupplierData } from 'Store/supplier/types'
import ConfirmPayDept from './components/confirm_paydept'
import { ExpireDate } from 'Components/utilities'
import { CreatePaymentReq } from 'Store/grn-payment/types'
import { createPaymentAPI } from 'Store/grn-payment/api'
import { getUserLogin } from 'helpers/account'
import { groupGrnByPurchase } from 'helpers/utils'

const { TabPane } = Tabs

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
}

const PayDept: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    supplierList,
    listEvent,
    list,
  } = props

  const dispatch = useDispatch()
  const [selectedGrn, setSelectedGrn] = useState([] as GrnData[])
  const [activeStatus, setActiveStatus] = useState(GrnStatus.EXPIRED as string)
  const [supplierID, setSupplierID] = useState(0 as number)
  const [showConfirm, setShowConfirm] = useState(false)
  const [selecteSupplier, setSelectSupplier] = useState(undefined as SupplierData | undefined)
  const userInfo = getUserLogin()
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const meta = list.meta
  const datas = list.data

  useEffect(() => {
    if (currentUser?.accessToken && supplierID > 0) {
      onGetList()
    }
  }, [pagination, selecteSupplier])

  useEffect(() => {
    const sup = supplierList && supplierList.find(item => item.id === supplierID)
    setSelectSupplier(sup)
  }, [supplierID])

  const onGetList = (): void => {
    const req: GrnListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      // statuses: [GrnStatus.PENDING, GrnStatus.PATIAL],
      statuses: [GrnStatus.PENDING],
    }
    if (selecteSupplier) {
      req['supplier_id'] = selecteSupplier?.id || 0
    }
    dispatch(grnListBySupActionAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const getGrnIds = () => {
    const ids = [] as number[]
    selectedGrn &&
      selectedGrn.forEach(item => {
        ids.push(item.id)
      })
    return ids
  }

  const onPayment = (): void => {
    setShowConfirm(false)
    const req: CreatePaymentReq = {
      supplier_id: selecteSupplier?.id || 0,
      grns: getGrnIds(),
      username: userInfo?.username || '',
    }
    dispatch(createPaymentAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (visible) {
      onGetDetail()
      setSelectedGrn([])
      setSupplierID(0)
    }
  }, [visible])

  const onGetDetail = (): void => {}

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setShowConfirm(false)
    clearEvent()
    onSuccess()
  }

  const countTotalPrice = () => {
    let price = 0
    selectedGrn &&
      selectedGrn.forEach(item => {
        price += item.total_recieve_price || 0
      })
    return price
  }

  const isSelected = (purchasing_no: string, grn_no: string) => {
    const data = selectedGrn.find(
      item => item?.purchasing?.purchasing_no == purchasing_no && item?.grn_no == grn_no,
    )
    return data ? true : false
  }

  const removeID = (data: GrnData) => {
    return selectedGrn.filter(
      item => item.purchasing?.purchasing_no != data.purchasing?.purchasing_no || item.grn_no != data.grn_no,
    )
  }

  const onSelectGrn = (data: GrnData) => {
    let newSelect = cloneDeep(selectedGrn) || []
    if (isSelected(data.purchasing?.purchasing_no || '', data.grn_no || '')) {
      newSelect = removeID(data)
    } else {
      newSelect.push({ ...data })
    }
    setSelectedGrn([...newSelect])
  }

  const onChangeTab = (key: string) => {
    setActiveStatus(key)
  }

  const renderDetail = (
    value: any,
    group: {
      purchasing_no: string
      grn: GrnData[]
    },
    index: number,
  ) => {
    const grnList = group.grn as GrnData[]
    return (
      <PoItem key={index}>
        <TitleWrapper>
          <Space size="small">เลขที่ใบสั่งซื้อ : {group.purchasing_no}</Space>
        </TitleWrapper>
        <OrderDetail>
          {grnList.map((grn, index: number) => {
            return (
              <GrnItem key={index}>
                <Row gutter={[18, 16]} align="middle">
                  <Col style={{ width: '5%' }}>
                    <Center>
                      <Checkbox
                        onChange={() => onSelectGrn({ ...grn, grn_no: grn.grn_no || '' })}
                        checked={isSelected(grn?.purchasing?.purchasing_no || '', grn.grn_no || '')}
                      />
                    </Center>
                  </Col>
                  <Col style={{ width: '15%' }}>{grn?.grn_no}</Col>
                  <Col style={{ width: '10%' }}>{numberWithComma(grn.total_recieve_amount)} </Col>
                  <Col style={{ width: '10%' }}>{numberWithComma(grn.total_recieve_price, true)}</Col>
                  <Col style={{ width: '20%' }}>
                    {formatDateWithoutTime(grn.purchasing?.purchasing_date || '')}{' '}
                  </Col>
                  <Col style={{ width: '20%' }}>{formatDateTime(grn.recieved_date || '')} </Col>
                  <Col style={{ width: '20%' }}>
                    {' '}
                    <ExpireDate date={grn?.payment_date || ''} direction="horizontal" />
                  </Col>
                </Row>
              </GrnItem>
            )
          })}
        </OrderDetail>
      </PoItem>
    )
  }

  const renderEmpty = () => {
    const obj = {
      children: '',
      props: {} as any,
    }
    obj.props.rowSpan = 0
    obj.props.colSpan = 0
    return obj
  }

  const columns = [
    {
      title: '',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '5%',
      render: (value: any, record: any, index: number) => {
        const obj = {
          children: renderDetail(value, record, index),
          props: {} as any,
        }
        obj.props.colSpan = 7
        return obj
      },
    },
    {
      title: 'เลขที่ใบจ่ายหนี้',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '15%',
      render: renderEmpty,
    },
    {
      title: 'จำนวนรายการ',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '10%',
      render: renderEmpty,
    },
    {
      title: 'ยอดที่ต้องชำระ',
      dataIndex: 'payment_type',
      key: 'payment_type',
      width: '10%',
      render: renderEmpty,
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '20%',
      render: renderEmpty,
    },
    {
      title: 'วันที่รับเข้าคลัง',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '20%',
      render: renderEmpty,
    },
    {
      title: 'วันที่ครบกำหนดชำระ',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '20%',
      render: renderEmpty,
    },
  ]

  const ConfirmModal = (
    <ConfirmPayDept
      onCloseModal={() => setShowConfirm(false)}
      onConfirm={onPayment}
      visible={showConfirm}
      supplier={selecteSupplier}
      grnList={selectedGrn}
    />
  )

  const renderFooterContent = () => {
    return (
      <Row justify="end" align="middle" gutter={[32, 8]}>
        <Col>
          <Space>
            ยอดรวมทั้งหมด <Price>{numberWithComma(countTotalPrice(), true)}</Price> บาท
          </Space>
        </Col>
        <Col>
          <PrimaryButton
            btnType="Primary"
            text={`ชำระหนี้ (${selectedGrn.length})`}
            onClick={() => setShowConfirm(true)}
            disabled={selectedGrn.length <= 0}
          />
        </Col>
      </Row>
    )
  }

  const FilterContent = (
    <FilterWrapper>
      <Row gutter={[16, 8]} align="middle" justify="center">
        <Col>เลือกบริษัท/Supplier ที่ต้องการจ่ายหนี้</Col>
        <Col xs={24} md={10}>
          <SelectItem
            name="supplier_id"
            label="เลือกบริษัท/Supplier ที่ต้องการจ่ายหนี้"
            placeHolder="เลือกบริษัท/Supplier"
            isRequired={true}
            value={supplierID}
            onChange={val => setSupplierID(parseInt(val))}
            menu={getSupplierMenuSelect(supplierList, 'name', 'id')}
            allowClear={false}
          />
        </Col>
      </Row>
    </FilterWrapper>
  )

  const getTab = () => {
    return (
      <Tabs onChange={onChangeTab} activeKey={activeStatus}>
        {menuPayDeptStatus.map((item: any) => {
          return <TabPane tab={item.name} key={item.value}></TabPane>
        })}
      </Tabs>
    )
  }

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const renderGRN = () => {
    return (
      <Row gutter={[16, 16]}>
        {/* <Col span={24}>{getTab()}</Col> */}
        <Col span={24}>
          <TableListPage
            columns={columns}
            datas={groupGrnByPurchase(datas)}
            isLoading={listEvent.IsLoading}
            paginationContent={PaginationContent}
            size="small"
            offsetHeader={-25}
          />
        </Col>
      </Row>
    )
  }

  return (
    <DetailDrawer
      title={'จ่ายหนี้หลายรายการ (สำหรับชำระเต็มจำนวน)'}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      width={'90%'}
      footer={renderFooterContent()}
    >
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      {ConfirmModal}
      {FilterContent}
      <Remark>
        หน้าเลือกชำระหนี้หลายรายการจะแสดงใบ GRN ที่ยังไม่เคยชำหนี้เลยมาแสดงให้ กรณีที่ร้านค้าต้องการชำระหนี้ใบ
        GRN ที่เคยชำระแล้วบางส่วน สามารถเลือกที่แถบ &quot;ชำระแล้วบางส่วน&quot; หรือค้นหาเพิ่มเติม
      </Remark>
      {supplierID <= 0 ? (
        <EmpryWrapper>
          <Empty description="กรุณาเลือก บริษัท/Supplier เพื่อดูรายการจ่ายหนี้" />
        </EmpryWrapper>
      ) : (
        renderGRN()
      )}
    </DetailDrawer>
  )
}

const FilterWrapper = styled.div`
  padding: 20px 0;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
`

const EmpryWrapper = styled.div`
  padding: 80px 0;
`

const PoItem = styled.div`
  width: 100%;
  border-radius: 5px;
  margin-bottom: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //border: 1px solid #f0f0f0;
`

const TitleWrapper = styled.div`
  width: 100%;
  padding: 5px 15px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const GrnItem = styled.div`
  width: 100%;
  padding: 10px 0;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  border: 1px solid #f0f0f0;
`

const OrderDetail = styled.div`
  padding: 10px;
  //border: 1px solid #f0f0f0;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  border-radius: 5px;
`

const Center = styled.div`
  text-align: center;
`

const Price = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`

const Remark = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  padding: 10px 200px;
  text-align: center;
`
const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectPaymentActionEvent(state),
    supplierList: selectAllSupplierList(state),
    list: selectGrnListBySub(state),
    listEvent: selectGrnListBySupEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PayDept)
